<!-- O2O 模块占位页 -->
<template>
  <el-card shadow="never">
    <el-empty :description="description">
      <el-tag type="info">B-P0 开发中</el-tag>
    </el-empty>
  </el-card>
</template>

<script setup lang="ts">
defineOptions({ name: 'MerchantO2oPlaceholder' })

defineProps<{
  description: string
}>()
</script>
